// NEW: UI_REVAMP
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

export function DrawerButton({ name, path, imgSrc, onClick }) {
	const location = useLocation();
	const isActive = path && location.pathname.includes(path);

	return (
		<Box
			position='relative'
			display='flex'
			alignItems='center'
			justifyContent='start'
			mx={4}
			p={2}
			borderRadius='8px'
			bg={
				isActive
					? `linear-gradient(
                            180deg,
                             rgba(135, 116, 254, 0.2) 0%,
                             rgba(135, 116, 254, 0.15) 40%,
                             rgba(135, 116, 254, 0.1) 100%
                         )`
					: 'transparent'
			}
			boxShadow={
				isActive
					? '1px 1px 3px 1px rgba(91, 6, 145, 0.1), 1px 1px 3px 1px rgba(91, 6, 145, 0.1)'
					: 'none'
			}
			sx={
				isActive
					? {
							filter: `
							  drop-shadow(0px 4px 8px rgba(60, 50, 120, 0.28))
                              drop-shadow(0px 1.5px 3px rgba(60, 50, 120, 0.18))
						`,
						}
					: {}
			}
		>
			<Flex
				width='100%'
				onClick={onClick}
				path={path}
				cursor='pointer'
				userSelect='none'
				align='center'
				gap={3}
			>
				<Image src={imgSrc} size={6} flexShrink={0} />
				<Text
					fontSize='20px'
					fontWeight='500'
					color={isActive ? 'rgba(57, 49, 107, 1)' : '#000000'}
					whiteSpace='nowrap'
				>
					{name}
				</Text>
			</Flex>
			{isActive && (
				<Box
					position='absolute'
					inset={0}
					borderRadius='8px'
					padding='1px'
					zIndex={2}
					pointerEvents='none'
					sx={{
						background: `linear-gradient(
                                                     to bottom right,
                                                     rgba(255,255,255,0.7) 0%,
                                                     rgba(255,255,255,0.4) 45%,
                                                rgba(255,255,255,0.0)  48%,
                                               
                                                     rgba(255,255,255,0.45) 70%,
                                                     rgba(255,255,255,0.45)  100%
                                                     
                                                 )`,
						WebkitMask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
						WebkitMaskComposite: 'destination-out',
						maskComposite: 'exclude',
					}}
				/>
			)}
		</Box>
	);
}

DrawerButton.propTypes = {
	name: PropTypes.string,
	path: PropTypes.string,
	imgSrc: PropTypes.string,
	onClick: PropTypes.func,
};
